<div [ngClass]="isDesktop ? 'desktop': 'mobile'" class="mat-form-field-outline mat-form-field-outline-thick">
  <ng-container *ngIf="!isFirstDepositBonusLottery else boostedoffer">
    <div *ngIf="!isDesktop" class="teaser-text">
      <div>1. <span i18n>Select bonus offer</span>:</div>
    </div>
    <div class="bonus" fxLayoutAlign="space-between center" fxLayout="row">
      <img [ngStyle]="(!(bonusList?.length>1) && isReady) && {'opacity': '0.6', 'filter': 'brightness(0.6)'}" class="bonus-img" src="{{licenceService.getKey('icon-bonus-box')}}" alt="icon-bonus">
      <div *ngIf="!selectedBonus else bonuspresentation" class="empty">
        <ng-container>
          <!-- <img src="{{licenceService.getKey('icon-bonus-box')}}" alt="icon-bonus"> -->


          <ng-container *ngIf="isDesktop">
            <div *ngIf="isReady else waiting">
              <div class="no-bonuses-text" *ngIf="!(bonusList?.length>1) else number" i18n>No bonus available at the moment.</div>

              <ng-template #number>
                {{bonusList?.length-1}}
              </ng-template>

              <ng-container *ngIf="bonusList?.length===2" i18n>bonus available</ng-container>
              <ng-container *ngIf="bonusList?.length>2" i18n>bonuses available</ng-container>
              <div class="no-bonus"><span i18n>No bonus selected.</span></div>
            </div>
            <ng-template #waiting>
              <div class="no-bonuses-text"><span i18n>loading</span>...</div>
            </ng-template>
          </ng-container>


          <ng-container *ngIf="!isDesktop" fxLayoutAlign="center center" fxLayout="column">
            <div *ngIf="isReady else waiting">
              <div style="text-transform: uppercase;" fxLayoutAlign="center center" fxLayout="row">
                <div class="no-bonuses-text" *ngIf="!(bonusList?.length>1) else number" i18n>No bonus available at the moment.</div>

                <ng-template #number>
                  {{bonusList?.length-1}}
                </ng-template>
                <ng-container *ngIf="bonusList?.length===2" i18n>bonus available</ng-container>
                <ng-container *ngIf="bonusList?.length>2" i18n>bonuses available</ng-container>
              </div>
              <!-- <ng-container *ngIf="bonusList?.length>=2" i18n>available</ng-container> -->
              <div class="no-bonus"><span i18n>No bonus selected.</span></div>
            </div>
            <ng-template #waiting>
              <div class="no-bonuses-text"><span i18n>loading</span>...</div>
            </ng-template>
          </ng-container>
          </ng-container>
      </div>
      <ng-template #bonuspresentation>
        <!-- <div class="image" fxLayoutAlign="start center" fxFlex="20"><img [src]="_selectedBonus.thumbnail?.url" />
              </div> -->
        <div class="info selected-bonus">
          <div class="container" fxLayoutAlign="center center" fxLayout="column">
            <div class="title"><span i18n>your bonus</span>:</div>
            <div class="name">{{selectedBonus.displayName}}</div>
            <!-- <div class="description">{{_selectedBonus.teaserText}}</div> -->
          </div>
        </div>
      </ng-template>
      <div *ngIf="bonusList?.length>1 || !isReady" class="select-icon">
        <button round-button size="small" filled="empty" color="accent" [ngClass]="{'spinner': !isReady}" *ngIf="!selectedBonus"><span *ngIf="isReady" i18n>activate</span></button>
        <img *ngIf="!!selectedBonus && !isDesktop" src="{{licenceService.getKey('icon-refresh')}}" alt="icon-edit">
        <button round-button size="small" filled="empty" color="accent" [ngClass]="{'spinner': !isReady}" *ngIf="!!selectedBonus && isDesktop" flexLayout="row" fxLayoutAlign="center center" fxLayoutGap="6px">
          <ng-container *ngIf="isReady">
            <span i18n>change</span>
            <img src="{{licenceService.getKey('icon-refresh-short')}}" alt="change">
          </ng-container>
        </button>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #boostedoffer>
  <ng-container *ngIf="!selectedBonus else bonuspresentationboost" class="empty">
    <div *ngIf="!isDesktop" class="teaser-text">
      <div *ngIf="isReady else defaultlabel">
        <span>1. {{teaser?.msg}}</span>&nbsp;<span *ngIf="countDown" class="counter">{{countDown?.minutes}}:{{countDown?.seconds}}m</span>
      </div>
      <ng-template #defaultlabel>
        <div>1. <span i18n>Select bonus offer</span>:</div>
      </ng-template>
    </div>
    <div class="bonus boosted" fxLayoutAlign="space-between center" fxLayout="row">
      <div class="teser-image"></div>

      <ng-container *ngIf="isDesktop">
        <div>
          <div class="title-text"><span>{{bonusList?.length>1 ? bonusList?.length-1 : 'NO' }} EXTRA </span>&nbsp;<span i18n>available</span></div>
          <div class="text" fxLayoutAlign="center center">
            <span>{{teaser?.msg}}</span>
            <div *ngIf="countDown">
              &nbsp;
              <span i18n>valid for:</span>
              &nbsp;
              <span *ngIf="countDown" class="counter">{{countDown?.minutes}}:{{countDown?.seconds}}m</span>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!isDesktop">
        <div *ngIf="isReady else waiting">
          <div class="text">{{bonusList?.length>1 ? bonusList?.length-1 : 'NO' }} EXTRA</div>
          <div class="text" i18n>available</div>
        </div>
        <ng-template #waiting>
          <div class="no-bonuses-text"><span i18n>loading</span>...</div>
        </ng-template>
      </ng-container>


      <div class="select-icon">
        <button round-button class="add-bonus" size="small" filled="filled" color="night" *ngIf="!selectedBonus" fxLayoutAlign="center center" i18n>
          <span *ngIf="isReady">add bonus</span>
          <mat-spinner *ngIf="!isReady" [diameter]="24" color="accent"></mat-spinner>
        </button>
        <img *ngIf="!!selectedBonus" src="{{licenceService.getKey('icon-refresh')}}" alt="icon-edit">
      </div>
    </div>

  </ng-container>
</ng-template>

<ng-template #bonuspresentationboost>
  <div *ngIf="!isDesktop && selectedBonus.externalId!==NULL_BONUS" class="teaser-text">
    <span>1. {{selectedBonus?.displayName}}</span>
  </div>
  <div class="bonus boosted selected" fxLayoutAlign="space-between center" fxLayout="row">
    <div class="teser-image"></div>
    <ng-container>
      <div>
        <div class="boosted-title"><span i18n>boosted offer</span></div>
        <div class="text">
          <span *ngIf="selectedBonus.externalId!==NULL_BONUS && isDesktop">{{selectedBonus?.displayName}}.</span>
          <div *ngIf="countDown">
            &nbsp;
            <span style="text-transform: lowercase;" i18n>valid for:</span>
            &nbsp;
            <span *ngIf="countDown" class="counter">{{countDown?.minutes}}:{{countDown?.seconds}}m</span>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="select-icon">
      <button round-button class="add-bonus" size="small" filled="filled" color="night" *ngIf="!selectedBonus" fxLayoutAlign="center center" i18n>
        <span *ngIf="isReady">add bonus</span>
        <mat-spinner *ngIf="!isReady" [diameter]="24" color="accent"></mat-spinner>
      </button>
      <img *ngIf="!!selectedBonus" src="{{licenceService.getKey('icon-refresh')}}" alt="icon-edit">
    </div>
  </div>

</ng-template>

<ng-template #loading>
  <div class="spinner-wrapper" fxLayoutAlign="center center">
    <mat-spinner [diameter]="30" color="accent"></mat-spinner>
  </div>
</ng-template>